import React from 'react';
import Pagos from '../containers/Pagos/PagosList';

const PagosSiempre = () => <Pagos desdeSiempre={true} />;

export default PagosSiempre;
